<script lang="ts">
  import type {GojiraCard} from '$lib/gojiras';

  export let card: GojiraCard | undefined = undefined;
  export let cardType: string | undefined = undefined;
  export let used: boolean = false;
  export let unknown: boolean = false;
  export let highlight: boolean = false;
</script>

{#if card}
  <button
    class={`${highlight ? 'border-4' : 'border-2'} w-32 p-2 m-2 ${
      used ? `border-gray-500 text-gray-500` : `border-black`
    }`}
    on:click
  >
    <!-- {#if cardType !== undefined}<span class="font-black">{cardType}</span>:{/if} -->
    <p>att:{card.attack} str:{card.strength}</p>
    <p>def:{card.defense} pro:{card.protection}</p>
  </button>
{:else}
  <button class={`border-2 p-2 m-2 ${used ? `border-gray-500 text-gray-500` : `border-black`}`} on:click>
    {#if unknown}?{:else}X{/if}
  </button>
{/if}
